import React, { useState }  from 'react';
import styled from 'styled-components';

const CheckboxListWrap = styled.div`
    margin: 0;
    padding: 0;
`
const InputWrap = styled.div`
    padding: 10px 15px;
    margin-bottom:15px;
    background-color: #EFF2F6;
    border-radius: 3px;
`
const CheckboxInput = styled.input`
    &&& {
        margin-right:10px ;
        &:focus {
            outline: none;
            box-shadow: none;
        }
    }
`
const Label = styled.label`
    vertical-align: unset;
`

const CheckboxList = ( {options,selected,onSelectedEvent} ) => {
    let [state, setState] = useState({       
        selected:selected,
    });

    let checkedValue = ( value ) => {
        if( state.selected !== undefined ){
            return state.selected.includes( value );
        }
        return;
    }
    const handleChecked = ( e ) => {
        const checkedList = state.selected;
        let index;
    
        if ( e.target.checked ) {
          // add the value of the checkbox to options array
          checkedList.push(e.target.value);
        } else {
          // or remove the value from the unchecked checkbox from the array
          index = checkedList.indexOf( e.target.value );
          checkedList.splice(index, 1);
        }
        setState({selected:checkedList});

        if(typeof onSelectedEvent === 'function'){
            onSelectedEvent(checkedList);
        } 
    }

    return (
        <CheckboxListWrap>
            { options.map((item,key) => {
                const uniqueID = item.value.substring(0, 3) + key;
                return (
                    <InputWrap key={key}>                       
                        <CheckboxInput type="checkbox" id={uniqueID} value={item.value} defaultChecked={checkedValue(item.value)} onClick={(event) => handleChecked(event)}/>
                        <Label for={uniqueID} >{item.label}</Label>
                    </InputWrap>
                )
            }) }
        </CheckboxListWrap>
    )
}

export default CheckboxList;